import {UavPointCloudEdit} from '@/admin/resources/uavPointClouds/UavPointClouds';

export default {
  edit: UavPointCloudEdit,
};
